export const CHUNK_SIZE = 16;
export const CHUNK_HEIGHT = 256;
export const CHUNKS_VERTICAL = CHUNK_HEIGHT / CHUNK_SIZE; // 16 chunks stacked
export const CHUNK_VOLUME = CHUNK_SIZE * CHUNK_SIZE * CHUNK_SIZE; // 4096

export const SEA_LEVEL = 64;
export const WORLD_SEED_DEFAULT = 42;

export const RENDER_DISTANCE = 8; // default chunks radius (player-configurable)
export const SERVER_TICK_RATE = 20; // ticks per second (50ms interval)
export const SERVER_TICK_INTERVAL = 1000 / SERVER_TICK_RATE;

export const GRAVITY = 32; // blocks per second squared
export const JUMP_VELOCITY = 9; // blocks per second
export const PLAYER_SPEED = 4.3; // blocks per second (Minecraft walk speed)
export const PLAYER_SPRINT_SPEED = 5.6;

export const PLAYER_WIDTH = 0.6;
export const PLAYER_HEIGHT = 1.8;
export const PLAYER_EYE_HEIGHT = 1.62;

export const INVENTORY_SIZE = 36;
export const HOTBAR_SIZE = 9;
export const MAX_STACK_SIZE = 64;

export const BLOCK_BREAK_REACH = 5; // blocks
export const BLOCK_PLACE_REACH = 5;

export const SPAWN_POINT = { x: 0, y: SEA_LEVEL + 20, z: 0 } as const;
